import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const failures = [{
  title: 'Los sermones largos no funcionan',
  desc: "porque el cerebro adolescente se 'apaga' a los 30 segundos de charla unidireccional."
}, {
  title: 'Quitar el celular o castigarlo',
  desc: "solo refuerza su idea de que eres el 'enemigo' del que debe protegerse."
}, {
  title: 'Esperar a que él cambie primero',
  desc: 'es una batalla perdida; tú eres el adulto que debe cambiar la dinámica del juego.'
}, {
  title: 'Los consejos genéricos de internet',
  desc: 'no sirven porque no te dan pasos específicos para cuando él te contesta mal en la cara.'
}];
export function FailedAttemptsSection() {
  return <section className="py-10 md:py-24 bg-maternal-beige" data-id="element-1">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-2">
        <div className="text-center mb-8 md:mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold text-maternal-brown mb-4" data-id="element-4">
            Por qué lo que has intentado no funciona
          </h2>
          <p className="text-lg text-maternal-lightBrown max-w-2xl mx-auto" data-id="element-5">
            Seguramente has probado de todo, pero las tácticas tradicionales
            solo levantan muros más altos.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-6">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-maternal-cream p-6 md:p-8 rounded-2xl shadow-sm border border-maternal-amber/20 flex items-start gap-4" data-id="element-7">
              <XCircle className="w-8 h-8 text-red-400 flex-shrink-0 mt-1" data-id="element-8" />
              <div data-id="element-9">
                <h3 className="text-xl font-bold text-maternal-brown mb-2" data-id="element-10">
                  {item.title}
                </h3>
                <p className="text-maternal-lightBrown leading-relaxed" data-id="element-11">
                  {item.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}